import { useTranslation } from "react-i18next";
import { ExpressCourierInfoDialog } from "~/components/express-courier-info-dialog.component";
import { EXPRESS_COURIER_OPERATING_HOURS } from "~/tooling/express-courier-operating-hours";

/**
 * Informational card for the reasoned `unavailable_time` header state
 * (FR-055–FR-058). Uses the light Ansay accent shell (bg-ansay-100), not the
 * available card's dark shell -- it has no badge, illustration, or dismiss
 * control: it states a currently-true fact rather than a promotion, so
 * there is nothing to dismiss for the rest of the session.
 */
export function ExpressAvailabilityHeaderOutsideHoursCard() {
	const { t } = useTranslation("common");

	return (
		<div
			data-testid="express-availability-header-outside-hours-card"
			className="flex w-full flex-col gap-3 rounded-xl bg-ansay-100 p-4"
		>
			<p className="text-body-sm tracking-[-0.28px] text-ansay-900">
				{t("header.outsideHoursCard.body", EXPRESS_COURIER_OPERATING_HOURS)}
			</p>
			<ExpressCourierInfoDialog
				trigger={
					<button
						type="button"
						className="w-fit cursor-pointer text-left text-body-sm-emphasis text-ansay-700"
					>
						{t("header.outsideHoursCard.learnMore")}
					</button>
				}
			/>
		</div>
	);
}
